import { FieldConfigDTO } from '../../../system/system-dtos';
import { StringUtils } from '../../../common/string-utils';
import { ActivatedRoute } from '@angular/router';
import { ManageComponent } from '../../../feature/manage/manage.component';
import { SettingsComponent } from '../../../feature/settings/settings.component';

export function createRefUrl(config: FieldConfigDTO, data: any, route: ActivatedRoute) {
  const { ref } = config;
  let url = `/${ref.entity}`;
  if (ref.code) {
    url += `/${StringUtils.convert(ref.code, data)}`;
  }
  if (ref.tab) {
    url += `/${ref.tab}`;
  }
  if (ref.nestedId) {
    url += `/${StringUtils.convert(ref.nestedId, data)}`;
  }

  return determineRootUrl(route) + url;
}

function determineRootUrl(route: ActivatedRoute): string {
  if (!route) {
    return '';
  } else if (route.component === ManageComponent) {
    return '/manage';
  } else if (route.component === SettingsComponent) {
    return '/settings';
  } else {
    return determineRootUrl(route.parent);
  }
}
